import { hydrateRoot } from 'react-dom/client'
import React from 'react'
import { ApolloProvider } from "@apollo/client/react";
import { createApolloClient } from './client'

import App from './App'
import { setCookieKey } from './pintor'
import config from './clientConfig'

import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev'

setCookieKey(config.cookieKey)

const { client } = createApolloClient({
  ssr: false,
  uri: config.graphQlUri,
  wsUri: config.graphQlWsUri,
})


if (!config.isProd) {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

hydrateRoot(
  document.getElementById('root'),
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>
)
